import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  usePersonalApiMutation,
  usePersonalQuery,
} from '../../../features/personal/personalApiSlice';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import Notification from '../../../components/common/Notification';
import { toast } from 'sonner';

const Personal = () => {
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [personalApi, { isLoading }] = usePersonalApiMutation();
  const {
    data,
    isLoading: dataLoading,
    isSuccess: dataSuccess,
  } = usePersonalQuery({ refetchOnMountOrArgChange: true });

  const initialValues = {
    first_name: data?.data.first_name || '',
    email: data?.data.email || '',
    mobile: data?.data.mobile || '',
  };

  const validationSchema = yup.object({
    first_name: yup.string().required('Please enter your name'),
    mobile: yup
      .string()
      .required('Please enter a phone number')
      .min(10, 'Maimum 10 numbers only')
      .max(10, 'Maximum 10 numbers only'),
    // mobile: yup.number().required('Please enter mobile number'),
  });
  const onSubmit = async (validationSchema) => {
    try {
      const accountData = await personalApi(validationSchema).unwrap();
      toast.success('Personal details updated');
      // setShowNotification(!showNotification);
    } catch (error) {
      if (!error) {
        setErrMsg('No Server Response');
      } else {
        setErrMsg(error.data.message);
      }
    }
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  if (dataLoading) return <div>Loading...</div>;

  if (dataSuccess) {
    return (
      <>
        <Notification isShow={showNotification} />
        <section aria-labelledby="personal-details-heading">
          <form onSubmit={formik.handleSubmit}>
            <div className="shadow sm:overflow-hidden w-full sm:rounded-md">
              <div className="bg-white py-6 px-4 sm:p-6">
                <div className="flex justify-between items-center">
                  <h2
                    id="personal-details-heading"
                    className=" flex text-lg font-bold leading-6 text-gray-900"
                  >
                    Personal Details
                  </h2>

                  <div className="flex">
                    <Link
                      type="button"
                      to={'..'}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(-1);
                      }}
                      className="flex w-full justify-center rounded-3xl mr-6 text-sm font-medium  shadow-smfocus:outline-none "
                    >
                      <ArrowLeftIcon
                        className="-ml-1 mr-2 h-5 w-5 text"
                        aria-hidden="true"
                      />
                      Back
                    </Link>
                  </div>
                </div>
                {errMsg && (
                  <div className="mt-2 text-sm text-red-600">{errMsg}</div>
                )}
                <div className="mt-6 grid grid-cols-3 gap-6">
                  <div className="">
                    <label
                      htmlFor="first_name"
                      className="block text-sm font-medium text-gray-900"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      id="first_name"
                      autoComplete="cc-given-name"
                      className="bg-inputbg border border-inputBorder mt-1 block w-full rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.first_name}
                    />
                    {formik.touched.first_name && formik.errors.first_name ? (
                      <div className="mt-2 text-sm text-red-600">
                        {formik.errors.first_name}
                      </div>
                    ) : null}
                  </div>

                  <div className="">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-900"
                    >
                      Email
                    </label>

                    <h1>{formik.values.email}</h1>

                    {/* <input
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="email"
                    className="bg-inputbg border border-inputBorder mt-1 block w-full rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="mt-2 text-sm text-red-600">
                      {formik.errors.email}
                    </div>
                  ) : null} */}
                  </div>

                  <div className="">
                    <label
                      htmlFor="mobile"
                      className="block text-sm font-medium text-gray-900"
                    >
                      Mobile
                    </label>
                    <input
                      type="number"
                      name="mobile"
                      id="mobile"
                      autoComplete="state"
                      className="bg-inputbg border border-inputBorder mt-1 block w-full rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.mobile}
                    />
                    {formik.touched.mobile && formik.errors.mobile ? (
                      <div className="mt-2 text-sm text-red-600">
                        {formik.errors.mobile}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="border border-t-gray-300 bg-white px-4 py-3 text-right sm:px-6">
                {isLoading ? (
                  <button
                    type="submit"
                    disabled
                    className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
                  >
                    <svg
                      role="status"
                      className="inline mr-3 w-4 h-4 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                    Loading...
                  </button>
                ) : (
                  <button
                    // disabled
                    disabled={!(formik.dirty && formik.isValid)}
                    type="submit"
                    className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </form>
        </section>
      </>
    );
  }
};

export default Personal;
